import React from 'react';
import { Form } from 'react-bootstrap';

interface FormFieldProps {
    label: string;
    required?: boolean;
    helpText?: string;
    error?: string;
    children: React.ReactNode;
    htmlFor?: string;
}

export const FormField: React.FC<FormFieldProps> = ({
    label,
    required = false,
    helpText,
    error,
    children,
    htmlFor
}) => {
    return (
        <Form.Group className="mb-3">
            <Form.Label htmlFor={htmlFor}>
                {label} {required && <span className="text-danger">*</span>}
            </Form.Label>
            {children}
            {helpText && <Form.Text className="text-muted">{helpText}</Form.Text>}
            {error && <Form.Control.Feedback type="invalid" className="d-block">{error}</Form.Control.Feedback>}
        </Form.Group>
    );
};
